var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "204.21 167.85 291.59 224.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m466.95 167.86c-7.2891 0.24609-14.195 3.3203-19.25 8.5781-53.637 53.75-94.594 98.645-144.38 149.45l-53.023-44.801c-5.6836-4.8047-13.043-7.1484-20.457-6.5195-7.418 0.63281-14.277 4.1875-19.066 9.8828-4.7891 5.6953-7.1133 13.062-6.4609 20.477 0.64844 7.4141 4.2266 14.262 9.9336 19.035l72.801 61.602c5.3555 4.5117 12.207 6.8516 19.207 6.5586 6.9961-0.28906 13.629-3.1914 18.594-8.1328 60.312-60.441 103.25-108.72 162.4-168 5.4492-5.2695 8.5312-12.52 8.543-20.098 0.007812-7.5781-3.0508-14.84-8.4883-20.121-5.4336-5.2812-12.777-8.1367-20.355-7.9102z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckList);
export default __webpack_public_path__ + "static/media/icon-check-list.76922d31f097f1b6eb0f5c43bedb51ee.svg";
export { ForwardRef as ReactComponent };